import { useContext } from 'react';
import { MapControlContext } from '../contexts/mapcontrol.context';
import { VenueFilesContext } from '../contexts/venuefiles.context';
import {
  getLevelFeatureDataArrayFromBuildingID
} from '../utils/utils';

// a hook to return level features and ordinals to be used by floor control components.
export default function useBuildingLevelUtilHooks() {
  const { levelsFeatures } = useContext(VenueFilesContext);
  const { buildingSelectedID } = useContext(MapControlContext);

  const associatedBuildingLevelFeatures = getLevelFeatureDataArrayFromBuildingID(
    buildingSelectedID,
    levelsFeatures
  );

  const ordinals = [
    ...(new Set(associatedBuildingLevelFeatures.map((fl: any) => fl.properties.ordinal)))
  ];
  const sortedLevelOrdinals = ordinals.sort(
    (a: any, b: any) => parseFloat(a) - parseFloat(b)
  )

  const ordinalToLevelFeatures: Record<number, any[]> = {};
  for (const levelFeature of associatedBuildingLevelFeatures){
    if (!(levelFeature.properties.ordinal in ordinalToLevelFeatures)){
      ordinalToLevelFeatures[levelFeature.properties.ordinal] = [];
    }
    ordinalToLevelFeatures[levelFeature.properties.ordinal].push(levelFeature);
  }

  return {
    associatedBuildingLevelFeatures,
    sortedLevelOrdinals,
    ordinalToLevelFeatures
  };
}
